import React, { useEffect } from "react";
import SurvayLayout from "@codex/containers/SurvayLayout";
import SurvayForm from "@codex/components/SurvayForm";
import Layout from "@codex/containers/Layout";
var Survay = function (props) {
    useEffect(function () {
        props.initSurvay();
        document.title = "Salary Survey";
    }, []);
    return (React.createElement(Layout, null,
        React.createElement(SurvayLayout, null,
            React.createElement(SurvayForm, { pageNum: props.page, questions: props.survays
                    .filter(function (q) { return q.page === props.page; })
                    .sort(function (a, b) { return a.sortOrder - b.sortOrder; }) }))));
};
export default Survay;



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/Survay.tsx
// module id = 1370
// module chunks = 0